module.exports = __webpack_public_path__ + "19f4f4887c171ec70d685e71a92a4b65.png";